import { Component, Input, ViewChild } from '@angular/core';
import { EntryImage } from '../entry-image';

declare var $: any;

@Component({
  selector: 'app-showimg',
  templateUrl: './showimg.component.html',
  styleUrls: ['./showimg.component.less']
})
export class ShowimgComponent {
  loading = true;
  eImage: EntryImage;
  isHidden = true;
  showDescription = true;
  undersize = false;

  toggleDisplay() {
    this.isHidden = !this.isHidden;
    if (this.isHidden) {
      // console.log('Zoom Disabled');
      $('div.modal-content').trigger('zoom.destroy');
    } else {
      // console.log('Zoom Enabled');
      $('div.modal-content').zoom({url: this.eImage.imgurl});
    }
  }

  @Input()
  set showDesc(show: boolean) {
    this.showDescription = show;
  }

  @Input()
  set entryImage(entryImage: EntryImage) {
    this.loading = true;
    this.eImage = entryImage;
    this.undersize = entryImage.undersize;
  }

  get entryImage() { return this.eImage; }

  constructor() {
  }

  onLoad() {
    this.loading = false;
    // console.log('Zoom Enabled Again');
    //$('div.modal-content').zoom({url: this.eImage.imgurl});
  }
}
